import React, { useEffect, useRef, useState } from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import dayjs from 'dayjs';
import './ret.css';
import { isMobile } from 'react-device-detect';

const Recommen =({imf,wesh})=>{
  

  const [recom, setrecom] = useState([]);
  const [byuns, setbyuns] = useState(wesh);
  

  if(byuns !== wesh){
    setbyuns(wesh);
  };
  
  useEffect(()=>{
    const fetch = async()=>{
        const kyou = dayjs().format("YYYY-MM-DD"); 
        const hoakin = await axios.get(`/api/recoman?sauce=${imf}&sesh=${byuns}&kyou=${kyou}`).then(kip=>{setrecom(kip.data)})
        .catch(err=>{
          const ata = err.response?.data;
          setrecom(ata);
        });
    };
    fetch();
    

},[byuns]);

return (
  <div>
  <h3>돌파연속</h3>
  {isMobile ? 
  <div className='recom'>
      {recom?.length>0 && recom.slice(0,3).map((kora, i)=><div className='recom2'>
        <Link to={"/ajo/"+kora.id} state={kora} className='recc mcc' replace={false}>
        <div className='recdiv'>
        <img src={process.env.PUBLIC_URL+'/upost/'+kora.poster}/>
        </div>
        <p className='mcc1'>{dayjs(kora.start).format('YY-MM-DD')} ~ {dayjs(kora.end).format('YY-MM-DD')}</p>
        <p className='mcc2'>{kora.title}<span className='mcc3'>{dayjs(kora.end).startOf('day').diff(dayjs().startOf('day'), 'day')< 0 ? "마감" : `D-${dayjs(kora.end).startOf('day').diff(dayjs().startOf('day'), 'day')}`}</span></p>
        </Link>
        </div>)}
  </div> :
    <div className='recomb'>
    {recom?.length>0 && recom.map((kora, i)=><div className='recom1'>
      <Link to={"/ajo/"+kora.id} state={kora} className='recc' replace={false}>
      <img src={process.env.PUBLIC_URL+'/upost/'+kora.poster}/>
      <p className='nonzz'>{dayjs(kora.start).format('YY-MM-DD')} ~ {dayjs(kora.end).format('YY-MM-DD')}</p>
      <p className='nonys'>{kora.title}<span className='nony'>{dayjs(kora.end).startOf('day').diff(dayjs().startOf('day'), 'day') < 0 ? "마감" : `D-${dayjs(kora.end).startOf('day').diff(dayjs().startOf('day'), 'day')}`}</span></p>
      </Link>
      </div>)}
</div>}
  </div>
    );
}
export default Recommen;
